/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable react-hooks/exhaustive-deps,
@typescript-eslint/no-unsafe-assignment,
@typescript-eslint/no-unsafe-call */
import { Box, Flex, Tab, TabList, Tabs, Tooltip } from '@chakra-ui/react';
import { Analytics } from 'cliengo-fe-utils';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { NAVBAR_HEIGHT } from '@/constants/layout';
import { CLIENT_MANAGER_ROUTES } from '@/constants/routes';
import { events } from '@/utils/segment/events';

/**
 * Tab style mirrored from rapidash's `StyledTab.component.tsx`:
 * underline (no pill background), regular weight, primary color when
 * selected. Keeps a consistent look when this app is iframed inside
 * the rapidash dashboard.
 */
const tabSx = {
  fontSize: '14px',
  fontWeight: 600,
  color: '#515151',
  px: '16px',
  py: '10px',
  marginBottom: '-1px',
  borderBottom: '2px solid transparent',
  textTransform: 'none' as const,
  _hover: { color: '#6150AD' },
  _selected: {
    color: '#6150AD',
    borderBottomColor: '#6150AD',
    fontWeight: 600,
  },
};

/**
 * Main Navbar of the application
 * Contains Tabs for navigating to applications pages
 * @see https://chakra-templates.dev/navigation/navbar
 * @see https://chakra-ui.com/docs/components/tabs#controlled-tabs
 */
export const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const routes: string[] = [
    CLIENT_MANAGER_ROUTES.messages,
    CLIENT_MANAGER_ROUTES.templates,
    CLIENT_MANAGER_ROUTES.blacklist,
  ];

  const [tabIndex, setTabIndex] = useState(() => {
    const index = routes.findIndex((route) =>
      location.pathname.includes(route)
    );

    return index < 0 ? 0 : index;
  });

  const navigateToIndex = (index: number) => {
    setTabIndex(index);
    navigate(routes[index]);
    Analytics.trackEvent(events.manager.layout.navbar.tabs[index]);
  };

  return (
    <Box
      position={'sticky'}
      top={0}
      zIndex={'sticky'}
      bg={'appBg'}
      height={NAVBAR_HEIGHT}
      borderBottom={1}
      borderStyle={'solid'}
      borderColor={'gray.200'}
      shadow={'lg'}
      py={'0.5'}
      width={'100%'}
    >
      <Flex align={'center'} px="24px" justify={'space-between'}>
        <Flex flex={1} display={'flex'} justifyContent={'flex-start'}>
          <Tabs
            variant={'unstyled'}
            colorScheme={'primary'}
            index={tabIndex}
            onChange={navigateToIndex}
          >
            <TabList borderBottom="1px solid" borderColor="gray.200">
              <div id="messages-tab">
                <Tooltip
                  label={t('manager.layout.navbar.tabs_tooltip.messages')}
                  hasArrow
                  placement="bottom"
                  bg="gray.700"
                  color="white"
                  fontSize="xs"
                  maxW="280px"
                  openDelay={300}
                >
                  <Tab sx={tabSx}>
                    {t('manager.layout.navbar.tabs.messages')}
                  </Tab>
                </Tooltip>
              </div>

              <div id="templates-tab">
                <Tooltip
                  label={t('manager.layout.navbar.tabs_tooltip.templates')}
                  hasArrow
                  placement="bottom"
                  bg="gray.700"
                  color="white"
                  fontSize="xs"
                  maxW="280px"
                  openDelay={300}
                >
                  <Tab sx={tabSx}>
                    {t('manager.layout.navbar.tabs.templates')}
                  </Tab>
                </Tooltip>
              </div>

              <Tooltip
                label={t('manager.layout.navbar.tabs_tooltip.blocked_numbers')}
                hasArrow
                placement="bottom"
                bg="gray.700"
                color="white"
                fontSize="xs"
                maxW="280px"
                openDelay={300}
              >
                <Tab sx={tabSx}>
                  {t('manager.layout.navbar.tabs.blocked_numbers')}
                </Tab>
              </Tooltip>
            </TabList>
          </Tabs>
        </Flex>
      </Flex>
    </Box>
  );
};
